import React, { useEffect } from 'react';
import ReactPaginate from 'react-paginate';
import './style.scss';

export type PaginationProps = {
  currentPage?: number;
  setCurrentPage: (page: number) => void;
  pageCount: number;
  // APIを呼ぶ関数
  fetchApi: () => void;
};

const MARGIN_PAGES_DISPLAYED_SIZE = 1; // 終端に表示する件数
const PAGE_RANGE_DISPLAYED_SIZE = 1; // 現在ページの前後に表示する件数

export const Pagination: React.FC<PaginationProps> = ({ currentPage, setCurrentPage, pageCount, fetchApi }) => {
  useEffect(() => {
    fetchApi();
  }, [currentPage]);

  const handlePaginate = (selectedItem: { selected: number }) => {
    setCurrentPage(selectedItem.selected + 1);
  };

  return (
    <ReactPaginate
      forcePage={currentPage ? currentPage - 1 : 0}
      pageCount={pageCount}
      pageRangeDisplayed={PAGE_RANGE_DISPLAYED_SIZE}
      marginPagesDisplayed={MARGIN_PAGES_DISPLAYED_SIZE}
      onPageChange={handlePaginate}
      // ラベル
      previousLabel="< 前へ"
      nextLabel="次へ >"
      // CSS系
      containerClassName={'pagination'}
      pageClassName={'pages pagination'}
      activeClassName={'active'}
      previousClassName={'pagination__previous'}
      nextClassName={'pagination__next'}
      breakClassName={'pagination__break'}
      disabledClassName={'pagination__disabled'}
    />
  );
};
